// tog'a #1952 (2026-09-14): «minus faqat qarzlarda» — jami (Итого) qiymatining ko'rinishi maydon NOMI bo'yicha.
//  qarz maydonlari (debt / result / balance / saldo) — ishora saqlanadi (qarz minusda ko'rinadi);
//  foyda maydonlari (profit / net) manfiy — «Убыток N» (Boshliq 3-qarori, sales/netProfit bilan bir xil);
//  qolgan hammasi (soni, summa, narx) manfiy bo'lsa — 0 (manfiy jami faqat ma'lumot siljishida chiqadi).
import React from "react"
import formatStringToNumber from "./formatStringToNumber"
import { safeConvertFixed } from "./safeConvertFixed"

export type TotalKind = "debt" | "profit" | "plain"

export function totalKind(key: string): TotalKind {
  const k = String(key || "")
  if (/debt|result|balance|saldo|qarz/i.test(k)) return "debt"
  if (/profit|^net|netProfit/i.test(k)) return "profit"
  return "plain"
}

/** Ekrandagi «Итого» katagi */
export function renderTotal(key: string, raw: any): React.ReactNode {
  const n = Number(raw) || 0
  const kind = totalKind(key)
  if (kind === "debt") return formatStringToNumber(safeConvertFixed(n))
  if (kind === "profit" && n < 0)
    return <span style={{ color: "#dc2626", fontWeight: 600 }}>Убыток {formatStringToNumber(safeConvertFixed(Math.abs(n)))}</span>
  return formatStringToNumber(safeConvertFixed(n < 0 ? 0 : n))
}

/** Excel eksportidagi jami (oddiy qiymat) */
export function exportTotal(key: string, raw: any): number | string {
  const n = Number(raw) || 0
  const kind = totalKind(key)
  if (kind === "debt") return n
  if (kind === "profit" && n < 0) return "Убыток " + Math.abs(n)
  return n < 0 ? 0 : n
}
